<template>
  <section
    :class="[
      'form-block glass-panel flex flex-col gap-4 rounded-xl p-5',
      '[&_a[href*=facebook\\.com]]:text-primary [&_a[href*=facebook\\.com]]:underline',
    ]"
  >
    <header v-if="title || switchable || $slots['top-right']" class="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
      <!-- Translated titles may carry inline markup (<sup>*</sup>). -->
      <h2
        v-if="title"
        :class="[ 'm-0 min-w-0 text-base font-semibold text-foreground [&_sup]:text-destructive', switchable && !disabled && 'cursor-pointer' ]"
        @click="() => switchable && !disabled && (checkboxValue = !checkboxValue)"
        v-html="title"
      />
      <div class="ml-auto flex shrink-0 items-center gap-3 whitespace-nowrap">
        <slot name="top-right" />
        <ui-switch
          v-if="switchable"
          v-model="checkboxValue"
          :disabled="disabled"
          :aria-label="plainTitle"
        />
      </div>
    </header>

    <p v-if="description" class="m-0 -mt-2 text-sm text-muted-foreground [overflow-wrap:anywhere]" v-html="description" />

    <div v-show="!switchable || checkboxValue" class="flex flex-col gap-5">
      <slot />
    </div>
  </section>
</template>

<script>
/**
 * A titled form section, optionally switchable (v-model).
 */
export default {
  name: 'FormBlock',
  props: {
    title: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
    modelValue: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    switchable: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    description: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
  },
  emits: [ 'update:modelValue' ],
  data() {
    return {
      checkboxValue: this.modelValue,
    };
  },
  computed: {
    plainTitle() {
      return String(this.title || '').replace(/<[^>]*>/g, '');
    },
  },
  watch: {
    modelValue(val) {
      this.checkboxValue = val;
    },
    checkboxValue(val) {
      this.$emit('update:modelValue', val);
    },
  },
};
</script>
